'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = Col;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  span: 12
};


var RESPONSIVE_TIERS = {
  span: 'col',
  sm: 'col-sm',
  md: 'col-md',
  lg: 'col-lg'
};

function Col(_ref) {
  var children = _ref.children,
      className = _ref.className,
      responsiveTiers = _ref.responsiveTiers,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['children', 'className', 'responsiveTiers']);

  var tiers = (0, _extends3.default)({}, RESPONSIVE_TIERS, responsiveTiers);
  var responsiveSettings = (0, _keys2.default)(tiers).reduce(function (settings, tier) {
    return rest[tier] ? settings.concat([tiers[tier] + '-' + rest[tier]]) : settings;
  }, []);

  return React.createElement(
    'div',
    (0, _extends3.default)({
      className: _classnames2.default.apply(undefined, ['col'].concat((0, _toConsumableArray3.default)(responsiveSettings), [className]))
    }, (0, _omit2.default)(rest, (0, _keys2.default)(tiers))),
    children
  );
}

Col.defaultProps = defaultProps;